// extracted by mini-css-extract-plugin
export var badge = "_sh-4";
export var selected = "_sh-1";
export var selectedOverlay = "_sh-5";
export var thumbnailButton = "_sh-0";
export var thumbnailFallback = "_sh-3";
export var thumbnailImage = "_sh-2";